import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { hrmNavigation } from './navigation/navigation';
import { locale as navigationEnglish } from './navigation/i18n/en';
import { locale as navigationVietnam } from './navigation/i18n/vn';
import { FuseNavigation } from '@fuse/types';
import { Subject } from 'rxjs';
import { AclService } from '@aes/acl/acl.service';
import { ApprovalRequestApiService } from './approval-request/services';
import { APPROVAL_REQUEST_MENU_TYPE } from '@appshared';
import { INumberOfApprovalRequest, NumberOfApprovalRequest } from 'app/shared/model/number-approval-request.model';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'app/services';

@Component({
  selector: 'app-hrm',
  templateUrl: './hrm.component.html',
  styleUrls: ['./hrm.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HrmComponent implements OnInit, OnDestroy {

  hrmNavigation: FuseNavigation[];

  private numberOfRequests: INumberOfApprovalRequest = new NumberOfApprovalRequest();
  private readonly destroy$ = new Subject<void>();

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _fuseNavigationService: FuseNavigationService,
    private _aclService: AclService,
    private _approvalRequestApiSrv: ApprovalRequestApiService,
    private _appService: AppService
  ) { }

  ngOnInit(): void {
    // Set the navigation translations
    this._fuseTranslationLoaderService.loadTranslations(navigationEnglish, navigationVietnam);

    // Get default navigation
    this.hrmNavigation = hrmNavigation;
    this.hrmNavigation = this._appService.translateLeftSideBar(this.hrmNavigation);

    // Register the navigation to the service
    this._fuseNavigationService.register('hrm', this.hrmNavigation);

    // Set the main navigation as our current navigation
    this._fuseNavigationService.setCurrentNavigation('hrm');

    // Get notified each time getAccountAbilityState state changes.
    this._aclService.getAccountAbilityState()
      .pipe(takeUntil(this.destroy$))
      .subscribe(ability => this.updateNotificationView());
    this.updateNotificationView();
  }

  ngOnDestroy(): void {
    this._approvalRequestApiSrv.closeAllEventSourceConnection();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateNotificationView(): void {
    this.registerNumberOfRequestChangedPerType(APPROVAL_REQUEST_MENU_TYPE.MANAGER, this.numberOfRequests.managerRequest);
  }

  private registerNumberOfRequestChangedPerType(type: string, numberOfCurrentRequest: number): void {
    this._approvalRequestApiSrv.countNumberOfApprovalRequest(type).subscribe((data: number) => {
      if (numberOfCurrentRequest != data) {
        numberOfCurrentRequest = data;
        this._fuseNavigationService.updateNavigationItem(type, {
          badge: {
            title: numberOfCurrentRequest,
          },
        });

        this._approvalRequestApiSrv.incomingRequestEvent.next('');
      }
    });
  }
}
